var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-form-group",
    { attrs: { label: _vm.label } },
    [
      _c(
        "v-select",
        {
          class: { "v-select-danger": _vm.danger },
          attrs: {
            state: _vm.danger ? false : null,
            "data-vv-as": _vm.label.toLowerCase(),
            name: _vm.name,
            placeholder: _vm.placeholder,
            options: _vm.listOptions,
            value: _vm.optionSelected,
            disabled: _vm.isDisabled,
            clearable: _vm.isClearable
          },
          on: { input: _vm.onInput },
          scopedSlots: _vm._u([
            {
              key: "spinner",
              fn: function() {
                return [
                  _vm.sanitaryCompaniesState.loading
                    ? _c("b-spinner", {
                        attrs: { small: "", variant: "primary" }
                      })
                    : _vm._e()
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c("span", { attrs: { slot: "no-options" }, slot: "no-options" }, [
            _vm._v("No hay empresas para el criterio de búsqueda")
          ])
        ]
      ),
      !_vm.isClearable
        ? _c("vs-icon", {
            directives: [
              {
                name: "tooltip",
                rawName: "v-tooltip",
                value: "Eliminar selección",
                expression: "'Eliminar selección'"
              }
            ],
            staticClass: "ml-2 mt-5 pt-1 cursor-pointer",
            attrs: {
              icon: "remove_circle_outline",
              size: "small",
              color: "danger"
            },
            on: { click: _vm.clearSanitary }
          })
        : _vm._e(),
      _vm.danger
        ? _c(
            "div",
            {
              staticClass:
                "con-text-validation span-text-validation-danger v-enter-to",
              staticStyle: { height: "19px" }
            },
            [
              _c("span", { staticClass: "span-text-validation" }, [
                _vm._v(" " + _vm._s(_vm.dangerText) + " ")
              ])
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }